/*
 * @Author: zhao - 🍉
 * @Date: 2022-02-14 20:55:47
 * @LastEditTime: 2022-02-14 23:21:12
 * @LastEditors: zhao - 🍉
 * @Description: 收房合同房租周期
 * @FilePath: /zhzj-admin/src/services/rentCycle.js
 */

import request from "../utils/request";


/**
* 房租周期-房租周期列表
*
* @export
* @param {{ page: number, pagesize?: number, keyword?: string }} data
*/
export function fetchDeviceList(data, option = {}) {
    return request({ url: '/platform/device/find_page', method: 'post', data, ...option })
}

/**
* 房租周期-获取房租周期详情
*
* @export
* @param {{id: number}} data
*/
export function fetchDeviceGet(data, option = {}) {
    return request({ url: '/platform/device/get', method: 'post', data, ...option })
}

/**
* 房租周期-更新房租周期
*
* @export
* @param {*} data
*/
export function fetchDeviceUpdate(data, option = {}) {
    return request({ url: '/platform/device/update', method: 'post', data, ...option })
}

/**
* 房租周期-新增房租周期
*
* @export
* @param {*} data
*/
export function fetchDeviceAdd(data, option = {}) {
    return request({ url: '/platform/device/add', method: 'post', data, ...option })
}

/**
* 房租周期-删除房租周期
*
* @export
* @param {{id: number}} data
*/
export function fetchDeviceDelete(params, option = {}) {
    return request({ url: '/platform/device/delete', method: 'post', params, ...option })
}



// WEBPACK FOOTER //
// ./src/services/device.js